import styled from "styled-components";

export const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: unset !important;

  .image {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40vmax;
    width: 100%;
  }
`;
